<template>
  <div
    v-if="!loading"
  >
    <assignment-details-form
      :assignment="assignment"
      :manager-level="false"
    />

    <router-link
      :to="{ name: 'speaker-dashboard' }"
    >
      Return to Dashboard
    </router-link>
  </div>
</template>

<script>
import BasePage from '../pages/BasePage';
import AssignmentDetailsForm from '../forms/AssignmentDetailsForm';
import AssignmentDataStructures from '../specials/AssignmentDataStructures';
import ScorecardMixin from '../specials/ScorecardMixin';

export default {
  components: {AssignmentDetailsForm},
  mixins: [BasePage, AssignmentDataStructures, ScorecardMixin],
  data() {
    return {
      loading: true,
      assignment: {},
    };
  },
  computed: {
    assignments: {
      cache: false,
      get() {
        return this.$store.getters.assignedAssignments;
      }
    },
  },
  methods: {
    basePageCreated() {
      this.loadAllAssignmentsData(false).then(() => {
        this.loading = false;
        if (!this.setCurrentAssignmentFromUrl()) {
          this.$router.push({ name: 'speaker-dashboard' });
        };
      });
    },
  }
};
</script>
